export enum SortType {
  DateAsc,
  DateDesc,
  CostAsc,
  CostDesc,
}
